











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Toggle extends Vue {
  @Prop() private value!: boolean;
  @Prop() private label!: string;

  private id: string = "toggle-" + Math.random();
}
